import { COMPANY_TYPES } from '../../../../utils/common'
import { MAIN_SCREEN } from '../../constant'

export const mainTabs = [
  {
    value: MAIN_SCREEN.COMPANY_ANALYSIS,
    name: 'dynamicReport.TAB_COMPANY',
  },
  {
    value: MAIN_SCREEN.PORTFOLIO_INSIGHT,
    name: 'dynamicReport.TAB_PORTFOLIO',
  },
]

export const dataSelectCompanyType = [
  {
    value: COMPANY_TYPES.CORPORATE,
    label: 'preferenceSetting.CORPORATE',
    isI18n: true,
  },
  {
    value: COMPANY_TYPES.BANK,
    label: 'preferenceSetting.BANK',
    isI18n: true,
  },
  {
    value: COMPANY_TYPES.NON_BANK,
    label: 'preferenceSetting.NON_BANK',
    isI18n: true,
  },
  {
    value: COMPANY_TYPES.SECURITIES,
    label: 'preferenceSetting.SERCURITY',
    isI18n: true,
  },
]

export const COVER_PAGE_ID = 'coverPageId'
